import { apiFetch } from "../base";

export function * getActivate ({ token }) {
	return yield apiFetch({
		endpoint: `/activate/${token}`,
		method: "GET",
		authenticated: false
	});
}

export function * postActivateResend (payload) {
	return yield apiFetch({
		endpoint: "/activate/resend",
		method: "POST",
		authenticated: false,
		body: JSON.stringify(payload)
	});
}
